/// <reference types="../import-meta-env" />

type Credentials = "include" | "same-origin";

export function getBackendUrl(): {
  backendBaseUrl: string;
  graphQlUrl: string;
  graphQlSubscriptionUrl: string;
  credentials: Credentials;
} {
  let backendUrl: string;
  let credentials: Credentials;

  if (import.meta.env.BACKEND_URI) {
    backendUrl = import.meta.env.BACKEND_URI;
    credentials = "include";
  } else {
    if (import.meta.env.PROD) {
      throw new Error("Critical runtime error: BACKEND_URI is not set");
    }

    // local dev setup
    backendUrl = `http://${location.host}/backend`;
    credentials = "same-origin";
  }

  return {
    backendBaseUrl: backendUrl,
    graphQlUrl: `${backendUrl}/graphql`,
    graphQlSubscriptionUrl: `${backendUrl}/graphql`,
    credentials,
  };
}
